import { Component, Input, ViewChild, ElementRef, OnInit } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'goto-url-control',
    templateUrl: 'goto-url.control.html',
    standalone: false,
})
export class GotoUrlControl extends ControlBase implements OnInit {
    @ViewChild('link', { static: true })
    public link: ElementRef;

    @Input()
    public url: string;

    @Input()
    public text: string;

    @Input()
    public translateText: string;

    public ngOnInit(): void {
        if (!this.url) {
            throw new Error('GotoUrlComponent url is empty');
        }
        if (!this.text && !this.translateText) {
            throw new Error('GotoUrlComponent translate is empty');
        }

        if (this.text) {
            this.link.nativeElement.innerText = this.text;
        } else {
            this.link.nativeElement.innerText = this.ioc.core.translation.getMessage(this.translateText);
        }
    }

    public onGoToUrlClick(): void {
        window.open(this.url);
    }
}
